import AppState, { SCREENS } from '@/js/AppState';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';
import classes from './ScreenHome.module.css';

import CanvasCharacter from '@/components/Dial/CanvasCharacter/CanvasCharacter';
import OptionsBlock from '@/components/Hud/OptionsBlock/OptionsBlock';
import UserWidget from '@/components/shared/UserWidget/UserWidget';
import SoundPlayer from 'react-sdk/SoundPlayer';
import Connect from './modules/Connect';
import EmailSent from './modules/EmailSent';
import FirstCo from './modules/FirstCo';
import Landing from './modules/Landing';


// import logo from "./logo.png";
import Footer from '@/components/shared/Footer/Footer';
import Logo from './Logo/Logo';

export const MODULES = {
  LANDING: "LANDING",
  CONNECT: "CONNECT",
  EMAIL_SENT: "EMAIL_SENT",
  FIRST_CO: "FIRST_CO",
}

const ScreenHome = ({userData, saveData}) => {

  let userValid = AppState.vertxClient._SessionToken
  const [currentState, setCurrentState] = useState(userValid ? MODULES.FIRST_CO : MODULES.LANDING);
  const emailConnect = useRef(null);

  // useEffect(() => {
  //   if (userValid) {
  //     if (AppState.group) // si connecté et déjà dans un groupe, on affiche direct l'écran de sélection des chapitres
  //       AppState.setScreen(SCREENS.MODULES)
  //     else
  //       setCurrentState(MODULES.FIRST_CO)
  //   }
  //   else
  //     setCurrentState(MODULES.LANDING)

  // }, []);


  return (
    <div className={classes.ScreenHome}>
      {userValid &&
      <div className={classes.userWidget}>
        <UserWidget userEmail={userData.getUserMail()} onDisconnect={() => setCurrentState(MODULES.LANDING)} />
      </div>}

      <Logo />

      <div className={classes.content} >

        {currentState == MODULES.LANDING && <Landing playCB={() => { setCurrentState(MODULES.CONNECT) }} />}
        {currentState == MODULES.CONNECT && <Connect onMailSentCB={(email) => { emailConnect.current = email; setCurrentState(MODULES.EMAIL_SENT) }} onBackCB={() => { setCurrentState(MODULES.LANDING) }} />}
        {currentState == MODULES.EMAIL_SENT && <EmailSent email={emailConnect.current} onCodeLogin={() => {
          if (AppState.group) // si déjà dans un groupe, on affiche direct l'écran de sélection des chapitres
            AppState.setScreen(SCREENS.MODULES)
          else
            setCurrentState(MODULES.FIRST_CO)
        } }/>}
        {currentState == MODULES.FIRST_CO && <FirstCo onDoneCB={() => { AppState.setScreen(SCREENS.MODULES) }}/>}
      </div>

      <div className={classes.chars_ctnr} >
        <img className={classes.chars} src={"data/images/LP_persos.png"} />
      </div>


      {/*<AudioButton in_game={false}/>*/}
      <OptionsBlock in_game={false}/>
      {/* <CanvasCharacter char_id="avatar"  /> */}
      {/* <Footer showCredits={false} /> */}

      <Footer />

    </div>

  );
};

export default  observer(ScreenHome)
